import React, { useContext } from 'react';

import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import s from './CardOrganizationList.module.scss';
import { GradientContext } from '../../containers/BasePage';
import classNames from 'classnames';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import CardOrganization from '../CardOrganization/CardOrganization';
import GradientBlurb from '../GradientBlurb/GradientBlurb';

const CardOrganizationList = ({
  showResultText = false,
  totalCount = 0,
  showNoHits = false,
  cards = [],
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const [ref, isVisible] = useIntersectionObserver(0, '', true);
  const gradient = useContext(GradientContext);

  const classes = classNames(s.Root, s[gradient], { [s.Visible]: isVisible });

  return (
    <div className={classes} ref={ref}>
      <div className={s.Container}>
        <GradientBlurb modifiers={['CardOrganizationList']} />
        <GradientBlurb modifiers={['CardOrganizationList--Right']} />
        <GradientBlurb modifiers={['CardOrganizationList--Bottom']} />
        <div className={s.CardListWrapper}>
          <p
            className={classNames(s.ResultText, {
              [s.Show]: showResultText && !isLoading,
            })}>
            {t('Organization.results', { count: totalCount })}
          </p>

          <div className={s.CardList}>
            {!isLoading &&
              cards.map((card, index) => (
                <CardOrganization key={index} {...card} />
              ))}
            {totalCount === 0 && (
              <div
                className={classNames(s.NoHitsWrapper, {
                  [s.Show]: !isLoading && showNoHits && cards.length === 0,
                })}>
                <h2 className={s.NoHitsTitle}>
                  {t('Organization.noHitsTitle')}
                </h2>
                <p className={s.NoHitsText}>{t('Organization.noHitsText')}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CardOrganizationList.propTypes = {};

export default CardOrganizationList;
